
import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { StarIcons } from '@/fsd/shared/ui/icons';
import type { MenuData, MenuItem } from '../types';

const createMenuItem = (
  route: {
    path: string;
    title: string;
    section: string;
  },
  label?: string
): MenuItem => ({
  to: route.path,
  label: label ?? route.title,
  section: route.section,
  icon: <StarIcons.hollow />,
});

export const rawMenuData = (): MenuData => ({
  Финансы: {
    items: {
      Отчёты: [
        createMenuItem(routes.pnl),
        createMenuItem(routes.dds),
        createMenuItem(routes.balance),
      ],
      Деньги: [
        createMenuItem(routes.banks),
        createMenuItem(routes.rules),
        createMenuItem(routes.cashbox),
        createMenuItem(routes.loans),
      ],
    },
  },

  Склад: {
    items: {
      Товародвижение: [
        createMenuItem(routes.orders),
        createMenuItem(routes.acceptance),
        createMenuItem(routes.shipment),
        createMenuItem(routes.movement),
        createMenuItem(routes.returns),
      ],
      Отчёты: [
        createMenuItem(routes.remains),
        createMenuItem(routes.mutualSettlements, 'Сверки'),
      ],
    },
  },

  Аналитика: {
    items: {
      Аналитика: [
        createMenuItem(routes.rnp),
      ],
    },
  },
});
